import { FaAngleDown as AngleDownIcon } from 'react-icons/fa';

export default AngleDownIcon;
